(() => {
  if(window.tiffanyFooter)return;window.tiffanyFooter=true;
  const media=matchMedia('(max-width:749px)');
  const menus=new Set();
  function scan(root=document){for(const menu of root.querySelectorAll('[data-footer-menu]')){
    if(menus.has(menu))continue;menus.add(menu);menu.open=!media.matches;
    menu.querySelector('summary').addEventListener('click',event=>{if(!media.matches)event.preventDefault();});
  }}
  media.addEventListener('change',()=>{for(const menu of menus){if(!menu.isConnected){menus.delete(menu);continue;}if(media.matches&&menu.contains(document.activeElement))menu.querySelector('summary').focus();menu.open=!media.matches;}});
  document.addEventListener('shopify:section:load',event=>scan(event.target));
  document.addEventListener('shopify:block:select',event=>{const menu=event.target.querySelector('[data-footer-menu]');if(menu)menu.open=true;});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(),{once:true});else scan();
})();
